import moment from "moment";
import React, { useState } from "react";
import { Popover, Tooltip } from "antd";
import { CameraOutlined, CloseCircleOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { EventButtonProps } from "../../../type/events.types";
import { Popconfirm } from "antd/lib";
import EventCoverImage from "../../../utils/event-cover-image";
import MediaUploadButton from "../../../utils/media-upload-button";
import { replaceSpaceWithHyphen } from "../../../../../utility/utility";
import { useNavigate } from 'react-router-dom';
import Locale from "../../../../../core/locale/locale";
import dayjs from "dayjs";
import ConfirmActionModal from "../../../../../common/ConfirmActionModal";
import { Event_Type } from "../../../../../constant/constant";
import { getTabByEventType } from "../../../utils/utils";

const EventButton: React.FC<EventButtonProps> = (props) => {

    const navigate = useNavigate();

    const [popoverOpen, setPopoverOpen] = useState(false);
    const [cancelState, setCancelState] = useState<{ id: string | null; reason: string; }>({id: null, reason: ""});

    const now = moment(); // get current date & time
    // combine date and time
    const eventStart = props.event.startTime
        ? moment(`${moment(props.event.start).format("YYYY-MM-DD")}
         ${props.event.startTime}`, "YYYY-MM-DD HH:mm")
        : moment(props.event.start).startOf("day");

    const isFutureEvent = now.isBefore(eventStart);

    const canCancel = isFutureEvent;

    const isEditable = dayjs(props.event.start).isAfter(
        dayjs().subtract(15, "day").startOf("day")
    );

    const isCancelled = props.event.eventStatus === 'CANCELLED';

    const isEventEditable = props.event.eventType === 'CUSTOM_EVENT' || props.event.eventType === 'TRAINING';

    function redirectToMediaPage() {
        const eventName = props.event.title;
        const tabPath = getTabByEventType(props.event.eventType);
        const eventFolderName = replaceSpaceWithHyphen(eventName).toLowerCase();
        navigate(`/highlights/media-hub/${tabPath}/${eventFolderName}`, {
            state: {
                eventId: props.event.id,
                eventName: eventFolderName
            }
        })
    }


    const content = (
        <div className={'event-info-container'}>
            <EventCoverImage
                isAdmin={props.isAdmin}
                className="event-card__image"
                event={props.event}
            />
            <div className="event-info-container__content">
                <div className={'event-info-container__header'}>
                    <h3 className="event-info-container__title">
                        {props.event.title}
                    </h3>
                    <span className={'event-info-container__photoCount'}>{props.event.photoCount} photos</span>
                </div>

                <div className="event-info-container__meta">
                    <div className="event-info-container__row">
                        <span className="event-info-container__label">Hosted By:</span>
                        <span className="event-info-container__value">
                        {props.event.hostBy || "N/A"}
                        </span>
                    </div>

                    <div className="event-info-container__row">
                        <span className="event-info-container__label">Venue:</span>
                        <span className="event-info-container__value">
                         {props.event.venue || "N/A"}
                       </span>
                    </div>

                    <div className="event-info-container__row">
                        <span className="event-info-container__label">Description:</span>
                        <div className="event-info-container__value description"
                              dangerouslySetInnerHTML={{__html: props.event.description || "N/A"}}/>
                    </div>
                </div>

                <div className="event-info-container__datetime">
                    {props.event.start ? dayjs(props.event.start).format(Locale.displayDateWithMonth) : ""} {" "}
                    {props.event.startTime &&
                    <>
                        {props.event.startTime} {'-'} {props.event.endTime}
                    </>}
                </div>
            </div>
            <div className={'event-action'}>
                {props.isAdmin && <MediaUploadButton event={props.event} onClick={() => setPopoverOpen(false)}
                />}
                <button
                    className={`hrms-events__action-btn media-upload-btn`}
                    onClick={redirectToMediaPage}
                >
                    <CameraOutlined/>
                    Visit Gallery
                </button>
            </div>
        </div>
    );

    const handleUpdate = () => {
        props.openEditEventModal(props.event.id);
    };

    const handleDelete = async (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        props.handleDeleteEvent(props.event.id);
    };


    const eventType = replaceSpaceWithHyphen(Event_Type[props.event.eventType as keyof typeof Event_Type].toLowerCase());

    return (
        <>
            <Popover
                content={content}
                trigger="click"
                classNames={{root: "custom-popover"}}
                open={popoverOpen}
                onOpenChange={(open) => setPopoverOpen(open)}
            >
                <div
                    onClick={() => setPopoverOpen(true)}
                    className={`event-type ${eventType}`}
                    style={{cursor: "pointer"}}
                >
                    <div className={`event-title ${isCancelled ? "cancelled" : ""}`}>
                        <Tooltip title={isCancelled ? 'Event cancelled' : ''}>
                            <span>{props.event.title}</span>
                        </Tooltip>
                    </div>


                    <div className={"event-icons"}>
                        {isEventEditable && (
                            <>

                                {
                                    !isCancelled && isEditable &&
                                    <Tooltip title={"Edit event"}>
                                        <button
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleUpdate()
                                            }}
                                            className={`edit-event-btn  ${props.isAdmin ? "show" : "hide"}`}
                                        >
                                            <EditOutlined/>
                                        </button>
                                    </Tooltip>

                                }

                                <Popconfirm
                                    title={'Are you sure to delete event?'}
                                    onConfirm={handleDelete}
                                    okText={'Delete'}
                                    classNames={{root:'event-delete-confirmation'}}
                                >
                                    <Tooltip title={"Delete event"}>
                                        <button
                                            onClick={(e) => e.stopPropagation()}
                                            className={`delete-event-btn ${props.isAdmin ? "show" : "hide"}`}
                                        >
                                            <DeleteOutlined className={"delete-button"}/>
                                        </button>
                                    </Tooltip>


                                </Popconfirm>
                                {props.isAdmin && canCancel && !isCancelled && (
                                    <Tooltip title={"Cancel event"}>
                                        <button
                                            className={'cancel-event-icon'}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setCancelState({
                                                    id: props.event.id,
                                                    reason: ""
                                                });
                                            }}
                                        >
                                            <CloseCircleOutlined/>
                                        </button>
                                    </Tooltip>
                                )}
                            </>
                        )}
                    </div>


                </div>
            </Popover>

            <ConfirmActionModal
                open={!!cancelState.id}
                title="Cancel Event"
                subtitle="Are you sure you want to cancel this event?"
                showInput
                inputPlaceholder="Enter cancellation reason (optional)"
                inputValue={cancelState.reason}
                onInputChange={(val) =>
                    setCancelState((prev) => ({...prev, reason: val}))
                }
                confirmText="Yes, cancel"
                cancelText="Go back"
                confirmDisabled={false}
                onCancel={() => setCancelState({id: null, reason: ""})}
                onConfirm={() => {
                    if (cancelState.id) {
                        props.handleCancelEvent(cancelState.id, cancelState.reason);
                        setCancelState({id: null, reason: ""});
                    }
                }}
            />
        </>
    );
};

export default EventButton;
